<template>
    <a-modal title="新增邮寄" :width="1300" :open="true" :maskClosable="false" :confirmLoading="state.confirmLoading"
        @ok="onFormSubmit" @cancel="
            () => {
                emit('cancel')
            }
        ">
        <a-spin :spinning="state.loading">
            <a-form ref="formRef" :model="formState" :rules="rules" v-bind="formLayout">
                <a-form-item label="邮寄公司名称"> {{ props.tableColumnsData.entityNameToRegister?.full_name }}</a-form-item>

                <a-form-item label="有多家公司一起邮寄" v-if="state.customer_list?.length > 0">
                    <a-checkbox-group v-model:value="formState.customer_ids" @change="calcRemark">
                        <a-checkbox v-for="(item, index) in state.customer_list" :key="index" :value="item.id">
                            {{ item.full_name }} <a-tag color="green">{{ item.business_type_name }}：{{
                                item.after_status_name }}</a-tag></a-checkbox>
                    </a-checkbox-group>
                </a-form-item>
                <a-form-item name="mailing_kdgs" label="快递公司" required>
                    <a-radio-group v-model:value="formState.mailing_kdgs" button-style="solid">
                        <a-radio-button :value="1"><img :src="formState.mailing_kdgs == 2 ? jdIconBlack : jdIconWhite"
                                style="width: 16px; margin-top: -3px; margin-right: 5px" /> 京东快递 </a-radio-button>
                        <a-radio-button :value="2"><img :src="formState.mailing_kdgs == 1 ? sfIconBlack : sfIconWhite"
                                style="width: 16px; margin-top: -3px; margin-right: 5px" /> 顺丰快递 </a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="付款方式">
                    <a-radio-group v-model:value="formState.pay_type" :options="plainOptions" />
                </a-form-item>
                <a-form-item label="特别备注"> <a-input style="width: 400px" v-model:value="formState.remark"
                        type="textarea"></a-input> </a-form-item>
                <a-form-item label="邮寄方式">
                    <a-radio-group v-model:value="formState.is_timing">
                        <a-radio :value="1"> 立马邮寄 </a-radio>
                        <a-radio :value="2"> 定时邮寄 </a-radio>
                        <a-radio :value="3"> 触发式自动邮寄 </a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="触发条件" v-if="formState.is_timing == 3" required>
                    <a-select v-model:value="formState.condition" placeholder="请选择触发条件" style="width: 400px">
                        <a-select-option :value="1">当外勤第一次已拿章时，自动触发邮寄</a-select-option>
                        <a-select-option :value="2">当外勤第一次上传营业执照时，自动触发邮寄</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="上门取货时间" v-if="formState.is_timing == 2" required>
                    <a-date-picker v-model:value="formState.timing_time" :format="format" show-time />
                </a-form-item>
                <div class="d-flex">
                    <div class="flex-1">
                        <a-form-item label="寄件人姓名" name="send_name" required has-feedback
                            :validate-status="checkdatastate.send_name">
                            <a-input placeholder="请输入寄件人姓名" v-model:value="formState.send_name" @change="
                                () => {
                                    checkdatastate.send_name = formState.send_name ? 'success' : 'error'
                                }
                            "></a-input>
                        </a-form-item>
                        <a-form-item label="寄件人电话" name="send_tel" required has-feedback
                            :validate-status="checkdatastate.send_tel">
                            <a-row>
                                <a-col :span="17">
                                    <a-input placeholder="请输入寄件人电话" v-model:value="formState.send_tel" @change="
                                        (v) => {
                                            phoneChange(formState.send_tel, 'send_tel')
                                        }
                                    "></a-input>
                                </a-col>
                                <a-col :span="7">
                                    <a-button :loading="formState.emailLoading_send" type="primary"
                                        @click="emailChange(1)" :icon="h(CloudDownloadOutlined)">自动获取</a-button>
                                </a-col>
                            </a-row>
                        </a-form-item>
                        <a-form-item label="寄件人省市区" name="send_paua" has-feedback
                            :validate-status="checkdatastate.send_paua">
                            <AddressCascader width="100%" v-model:value="formState.send_paua"
                                @change="senderPauaChange"> </AddressCascader>
                        </a-form-item>
                        <a-form-item label="寄件人详细地址" name="send_address" required has-feedback
                            :validate-status="checkdatastate.send_address">
                            <a-textarea placeholder="请选择寄件人详细地址" v-model:value="formState.send_address"
                                @change="senderAddressChange"></a-textarea>
                            <a-button type="primary" @click="parseReceiveAddress"
                                :loading="state.parseReceiveAddressLoading" style="margin-top:5px"
                                :icon="h(ScanOutlined)">识别</a-button>
                        </a-form-item>
                    </div>
                    <div class="flex-1">
                        <a-form-item label="收件人姓名" name="receive_name" required has-feedback
                            :validate-status="checkdatastate.receive_name">
                            <a-input v-model:value="formState.receive_name" placeholder="请输入收件人姓名" @change="
                                () => {
                                    checkdatastate.receive_name = formState.receive_name ? 'success' : 'error'
                                }
                            "></a-input>
                        </a-form-item>
                        <a-form-item label="收件人电话" name="receive_tel" required has-feedback
                            :validate-status="checkdatastate.receive_tel">
                            <a-row>
                                <a-col :span="17">
                                    <a-input v-model:value="formState.receive_tel" @change="
                                        (v) => {
                                            phoneChange(formState.receive_tel, 'receive_tel')
                                        }
                                    " placeholder="请输入收件人电话"></a-input>
                                </a-col>
                                <a-col :span="7">
                                    <a-button :loading="formState.emailLoading_receive" type="primary"
                                        @click="emailChange(2)" :icon="h(CloudDownloadOutlined)">自动获取</a-button>
                                </a-col>
                            </a-row>
                        </a-form-item>
                        <a-form-item label="收件人省市区" name="receive_paua" has-feedback
                            :validate-status="checkdatastate.receive_paua">
                            <AddressCascader width="100%" v-model:value="formState.receive_paua"
                                @change="recipientChange"> </AddressCascader>
                        </a-form-item>
                        <a-form-item label="收件人详细地址" name="receive_address" required has-feedback
                            :validate-status="checkdatastate.receive_address">
                            <a-textarea placeholder="请选择收件人详细地址" v-model:value="formState.receive_address"
                                @change="receiveAddressChange"></a-textarea>
                            <a-button type="primary" @click="parseReceiveAddress2"
                                :loading="state.parseReceiveAddressLoading2" style="margin-top:5px"
                                :icon="h(ScanOutlined)">识别</a-button>
                        </a-form-item>
                    </div>
                </div>
            </a-form>
        </a-spin>
        <!-- 提示 -->
        <a-modal v-model:open="state.showtip" title="提示" @ok="handleTipOk">
            <ExclamationCircleOutlined style="color: red;" />&nbsp;&nbsp;&nbsp;{{ state.tipinfo }}
        </a-modal>
    </a-modal>
</template>

<script lang="ts" setup>
import { AddressCascader } from '@/components'
import cloneDeep from 'lodash.clonedeep'
import baseService from '@/utils/http/axios'
import dayjs from 'dayjs'
import { ref, reactive, onMounted, h } from 'vue'
import { message } from 'ant-design-vue'
import sfIconBlack from '@/assets/icons/sf-icon-black.png'
import sfIconWhite from '@/assets/icons/sf-icon-white.png'
import jdIconBlack from '@/assets/icons/jd-icon-black.png'
import jdIconWhite from '@/assets/icons/jd-icon-white.png'
import { parseAddress } from '@/utils/util'
import { ScanOutlined, CloudDownloadOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
const props = defineProps({
    tableColumnsData: {
        type: Object,
        default: () => null
    },
    copyNumber: {
        type: String,
        default: ''
    }
})
const emit = defineEmits(['cancel', 'ok'])
const format = 'YYYY-MM-DD HH:mm:ss'
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 }
    }
}
onMounted(() => {
    queryCustomerSf()
})
const plainOptions = [
    { label: '寄付(顺丰速运小程序->查快递->待支付付款)', value: 1 },
    { label: '到付', value: 2 }
]
interface state {
    customer_list: any[]
    storeShelfCode: number
    remark: string
    loading: boolean
    confirmLoading: boolean
    oldshengshiqu_send: string
    oldshengshiqu_receive: string
    parseReceiveAddressLoading: boolean
    parseReceiveAddressLoading2: boolean
    showtip: boolean
    tipinfo: string
}
const checkdatastate = reactive<any>({})
const state = reactive<state>({
    customer_list: [],
    storeShelfCode: 0,
    remark: '',
    loading: false,
    confirmLoading: false,
    oldshengshiqu_send: '',
    oldshengshiqu_receive: '',
    parseReceiveAddressLoading: false,
    parseReceiveAddressLoading2: false,
    showtip: false,
    tipinfo: ''
})
const formRef = ref()
interface from {
    mailing_kdgs: number
    pay_type: number
    is_timing: number
    remark: string
    timing_time: any
    customer_ids: any[]
    receive_address: string
    receive_paua: string
    receive_tel: string
    receive_name: string
    send_address: string
    send_paua: string
    send_tel: string
    send_name: string
    emailLoading_send: boolean
    emailLoading_receive: boolean
    xftel: string,
    condition: number | null
}
const formState = reactive<from>({
    mailing_kdgs: 1,
    pay_type: 1,
    is_timing: 1,
    remark: '',
    customer_ids: [],
    timing_time: null,
    receive_address: '',
    receive_paua: '',
    receive_tel: '',
    receive_name: '',
    send_address: '',
    send_paua: '',
    send_tel: '',
    send_name: '',
    emailLoading_send: false,
    emailLoading_receive: false,
    xftel: '',
    condition: null
})
const rules = reactive({
    send_paua: [{ required: true, message: '请选择寄件人地址' }],
    receive_paua: [{ required: true, message: '请选择收件人地址' }]
})
// 获取邮寄信息
const emailChange = (type) => {
    if (!formState.xftel && !formState.send_tel) {
        message.warn('请填写续费联系人手机号码或寄件人手机号码后再获取邮寄信息')
        return
    }

    let requeryParam = {
        url: '/admin/v1/mailingAddressList',
        method: 'post',
        data: {
            page: 1,
            limit: 'all',
            customer_tel: formState.receive_tel ?? formState.xftel
        }
    }
    if (type == 1) {
        requeryParam['data']['customer_tel'] = formState.send_tel
        formState.emailLoading_send = true
    } else {
        formState.emailLoading_receive = true
    }
    baseService(requeryParam)
        .then((res: any) => {
            if (res.data.list?.length > 0) {
                if (type == 2) {
                    formState.receive_name = res.data.list[0].name
                    formState.receive_tel = res.data.list[0].tel
                    formState.receive_address = res.data.list[0].address
                    formState.receive_paua = `${res.data.list[0].recipient_province_id},${res.data.list[0].recipient_city_id},${res.data.list[0].recipient_area_id}`
                } else {
                    formState.send_name = res.data.list[0].name
                    formState.send_tel = res.data.list[0].tel
                    formState.send_address = res.data.list[0].address
                    formState.send_paua = `${res.data.list[0].recipient_province_id},${res.data.list[0].recipient_city_id},${res.data.list[0].recipient_area_id}`
                }
            }
            message.success(res.msg)
            formState.emailLoading_send = false
            formState.emailLoading_receive = false
        })
        .catch((res) => {
            if (res) {
                formState.emailLoading_send = false
                formState.emailLoading_receive = false
                if (res.msg) {
                    message.warning(res.msg)
                    return
                }
            }
        })
    //   }
}
const queryCustomerSf = () => {
    state.loading = true
    let requestParam = {
        url: `/admin/v1/customerSf?customer_id=${props.tableColumnsData.id}&copyNumber=${props.copyNumber}`,
        method: 'get'
    }
    baseService(requestParam)
        .then((res) => {
            formState.mailing_kdgs = res.data.mailing_kdgs
            formState.pay_type = res.data.payment_type
            state.customer_list = res.data.customer_list
            state.storeShelfCode = res.data.storeShelfCode
            state.remark = res.data.remark
            formState.remark = res.data.remark
            calcRemark()
            let send: any = res.data.send
            formState.send_name = send.name
            formState.send_tel = send.tel
            formState.send_paua = `${send.provinceid},${send.cityid},${send.areaid}`
            formState.send_address = send.address
            let receive: any = res.data.receive
            formState.receive_name = receive.name
            formState.receive_tel = receive.tel
            if (receive?.provinceid && receive.cityid && receive.areaid) {
                formState.receive_paua = `${receive.provinceid},${receive.cityid},${receive.areaid}`
            }
            formState.receive_address = receive.address
            formState.xftel = res.data.xftel
            state.loading = false
            checkdatastate.send_name = formState.send_name ? 'success' : 'error'
            phoneChange(formState.send_tel, 'send_tel')
            checkdatastate.send_paua = formState.send_paua ? 'success' : 'error'
            checkdatastate.send_address = formState.send_address ? 'success' : 'error'
            //如果有提示
            if (res.data.tip) {
                state.showtip = true
                state.tipinfo = res.data.tip
            }
        })
        .catch((res) => {
            message.error(res?.mas ? res.msg : '自动获取失败请手动输出信息')
            state.loading = false
        })
}

const phoneChange = (v, type) => {
    let str = v.replaceAll(/\D/g, '')
    //判断str是不是手机号码
    if (!/^1[23456789]\d{9}$/.test(str)) {
        checkdatastate[type] = 'error'
    } else {
        checkdatastate[type] = 'success'
        formState[type] = str
    }
}

const calcRemark = () => {
    let remark = state.remark
    let arr: number[] = []
    if (state.storeShelfCode) {
        arr.push(state.storeShelfCode)
    }
    state.customer_list.forEach((item) => {
        //判断item.id 是否在 formState.customer_ids 中
        if (formState.customer_ids.indexOf(item.id) !== -1) {
            if (item.storeShelfCode) {
                arr.push(item.storeShelfCode)
            }
        }
    })
    if (arr.length > 0) {
        remark = remark + '【' + arr.join('、') + '】'
    }
    formState.remark = remark
}
const senderPauaChange = (e, val) => {
    let address = ''
    if (val) {
        checkdatastate.send_paua = 'success'
        //开始处理addresss
        address = `${val[0].name}${val[1].name}${val[2].name}`
        if (state.oldshengshiqu_send && formState.send_address) {
            formState.send_address = formState.send_address.replace(state.oldshengshiqu_send, '')
        }
        state.oldshengshiqu_send = address //把当前的选中的省市区赋值给一个变量
        formState.send_address = formState.send_address ? address + formState.send_address : address
        checkdatastate.send_address = formState.send_address == address ? 'error' : 'success'
    } else {
        checkdatastate.send_paua = 'error'
    }
}
const recipientChange = (e, val) => {
    let address = ''
    if (val) {
        checkdatastate.receive_paua = 'success'
        //开始处理addresss
        address = `${val[0].name}${val[1].name}${val[2].name}`
        if (state.oldshengshiqu_receive && formState.receive_address) {
            formState.receive_address = formState.receive_address.replace(state.oldshengshiqu_receive, '')
        }
        state.oldshengshiqu_receive = address //把当前的选中的省市区赋值给一个变量
        formState.receive_address = formState.receive_address ? address + formState.receive_address : address
        checkdatastate.receive_address = formState.receive_address == address ? 'error' : 'success'
    } else {
        checkdatastate.receive_paua = 'error'
    }
}
const onFormSubmit = () => {
    if (formState.is_timing == 3 && !formState.condition) {
        message.error('请选择触发条件！')
        return
    }
    formRef.value.validate().then(() => {
        let data: any = cloneDeep(formState)
        let param: any = {}
        data.customer_ids.push(props.tableColumnsData.id)
        param.customer_ids = data.customer_ids
        param.send = {
            provinceid: parseInt(data.send_paua.split(',')[0]),
            cityid: parseInt(data.send_paua.split(',')[1]),
            areaid: parseInt(data.send_paua.split(',')[2]),
            address: data.send_address,
            tel: data.send_tel,
            name: data.send_name
        }
        param.receive = {
            provinceid: parseInt(data.receive_paua.split(',')[0]),
            cityid: parseInt(data.receive_paua.split(',')[1]),
            areaid: parseInt(data.receive_paua.split(',')[2]),
            address: data.receive_address,
            tel: data.receive_tel,
            name: data.receive_name
        }
        param.timing_time = dayjs(data.timing_time, format)
        param.condition = data.condition
        param.remark = data.remark
        param.pay_type = data.pay_type
        param.mailing_kdgs = data.mailing_kdgs
        param.is_timing = data.is_timing
        param.full_name = props.tableColumnsData.entityNameToRegister?.full_name
        state.confirmLoading = true
        let requestParam = {
            url: `/admin/v1/customerSfPush`,
            method: 'post',
            data: param
        }
        baseService(requestParam)
            .then((res: any) => {
                state.confirmLoading = false
                message.success(res?.msg ? res.msg : '发送成功', 8)
                emit('cancel')
            })
            .catch((res) => {
                state.confirmLoading = false
                message.error(res?.msg ? res.msg : '操作失败请联系管理员')
            })
    })
}
//寄件人详细地址改变
const senderAddressChange = () => {
    if (formState.send_address) {
        checkdatastate.send_address = state.oldshengshiqu_send == formState.send_address ? 'error' : 'success'
    } else {
        checkdatastate.send_address = 'error'
    }
    //   if (formState.send_paua) {
    //     let arr = formState.send_paua.split(',')
    //     let requestParam = {
    //       url: '/admin/areaList?province=' + arr[0] + '&city=' + arr[1] + '&area=' + arr[2],
    //       method: 'get'
    //     }
    //     baseService(requestParam).then((res: any) => {
    //       if (res.data.length == 3) {
    //         let head3 = res.data[0].name + res.data[1].name + res.data[2].name
    //         let head2 = res.data[1].name + res.data[2].name
    //         let head1 = res.data[2].name
    //         formState.send_address = formState.send_address.trim()
    //         if (formState.send_address.indexOf(head3) == 0) {
    //           formState.send_address = formState.send_address.replace(head3, '')
    //         } else if (formState.send_address.indexOf(head2) == 0) {
    //           formState.send_address = formState.send_address.replace(head2, '')
    //         } else if (formState.send_address.indexOf(head1) == 0) {
    //           formState.send_address = formState.send_address.replace(head1, '')
    //         }
    //         formState.send_address = head3 + formState.send_address
    //       }
    //     })
    //   }
}
const receiveAddressChange = () => {
    if (formState.receive_address) {
        checkdatastate.receive_address = state.oldshengshiqu_receive == formState.receive_address ? 'error' : 'success'
    } else {
        checkdatastate.receive_address = 'error'
    }
    //   if (formState.receive_paua) {
    //     let arr = formState.receive_paua.split(',')
    //     let requestParam = {
    //       url: '/admin/areaList?province=' + arr[0] + '&city=' + arr[1] + '&area=' + arr[2],
    //       method: 'get'
    //     }
    //     baseService(requestParam).then((res: any) => {
    //       if (res.data.length == 3) {
    //         let head3 = res.data[0].name + res.data[1].name + res.data[2].name
    //         let head2 = res.data[1].name + res.data[2].name
    //         let head1 = res.data[2].name
    //         formState.receive_address = formState.receive_address.trim()
    //         if (formState.receive_address.indexOf(head3) == 0) {
    //           formState.receive_address = formState.receive_address.replace(head3, '')
    //         } else if (formState.receive_address.indexOf(head2) == 0) {
    //           formState.receive_address = formState.receive_address.replace(head2, '')
    //         } else if (formState.receive_address.indexOf(head1) == 0) {
    //           formState.receive_address = formState.receive_address.replace(head1, '')
    //         }
    //         formState.receive_address = head3 + formState.receive_address
    //       }
    //     })
    //   }
}
//识别收货地址
const parseReceiveAddress = () => {
    state.parseReceiveAddressLoading = true
    parseAddress(formState.send_address).then((res: any) => {
        if (res.name) {
            formState.send_name = res.name
        }
        if (res.phone) {
            formState.send_tel = res.phone
        }
        if (res.area_ids) {
            formState.send_paua = res.area_ids
        }
        if (res.address) {
            formState.send_address = res.address
        }
    }).catch((res) => {
        message.error(res)
    }).finally(() => {
        state.parseReceiveAddressLoading = false
    })
}
const parseReceiveAddress2 = () => {
    state.parseReceiveAddressLoading2 = true
    parseAddress(formState.receive_address).then((res: any) => {
        if (res.name) {
            formState.receive_name = res.name
        }
        if (res.phone) {
            formState.receive_tel = res.phone
        }
        if (res.area_ids) {
            formState.receive_paua = res.area_ids
        }
        if (res.address) {
            formState.receive_address = res.address
        }
    }).catch((res) => {
        message.error(res)
    }).finally(() => {
        state.parseReceiveAddressLoading2 = false
    })
}
const handleTipOk = () => {
    state.showtip = false
}
</script>

<style lang="less" scoped></style>
